export const InitialProductDuplicateFormData = {
  quality: [],
  price: [],
  discount_amount: [],
  discount_type: [],
  effect_from: [],
  effect_to: [],
};
export const InitialCartoonStockDuplicateFormData = {
  cartoon_type: [],
  quantity: [],
  price_per_cartoon: [],
};
export const InitialPlasticStockDuplicateFormData = {
  plastic_type: [],
  quantity: [],
  price_per_plastic: [],
};

export const InitialCartoonWithDrawDuplicateFormData = {
  product_id: "",
  product_qty: "",
  cartoon_qty: "",
  product_quality: "",
  production_date: "",
};

export const InitialPlasticWithDrawDuplicateFormData = {
  product_id: "",
  product_qty: "",
  plastic_qty: "",
  product_quality: "",
  production_date: "",
};

// export const InitialLeafStockDuplicateFormData = {
//   purchase_date: "",
//   bill_number: "",
//   vendor: "",
//   leaf_type: "",
//   quantity: "",
//   price_per_leaf: "",
//   paid_amount: "",
//   mileage: "",
//   overal_cost: "",
//   distance_travel: "",
//   hiring_cost: "",
// };
